<script>
    import router from "page";
    import { onMount } from "svelte";

    import { fetchGet, fetchPatch } from "../utils/utilsFetch.js";

    import {
        messageObject,
        isLoading,
        productModalSku,
        showProductModal,
        client,
        locale,
    } from "../stores.js";

    let company = {},
        products = [];

    onMount(async () => {
        $isLoading = true;

        products = await fetchGet(`/api/products/most-popular`);
        console.log(products);

        $isLoading = false;
    });
</script>

<div class="container">
    <div class="company">
        <span style="font-size: 20px; font-weight: bold;">
            {$locale.popularProducts || ""}
        </span>
        <span style="font-size: 15px; opacity: 0.5;">
            {$locale.pricesAre || ""}
            <b style="color: red;">{$locale.withoutVat || ""}</b>
        </span>

        <span style="margin-left: auto;">
            <b>{$locale.discountGroup || ""}:</b>
            {$client.discountGroup}
        </span>
    </div>

    <div class="products">
        {#each products as product}
            <div
                class="product"
                on:click={() => {
                    $productModalSku = product.sku;
                    $showProductModal = true;
                }}
            >
                <img src="/pics/resampled/{product.sku}.jpg" alt="" />

                <span class="name">
                    <b>{product.sku}</b> - {product.product}
                </span>

                {#if !$client.isHiddenPrices}
                    <span class="price">
                        {product.clientPriceWithoutVat}
                        <span class="currency"> {$locale.currency || ""}</span>
                    </span>
                {/if}
            </div>
        {/each}
    </div>
</div>

<style>
    .container {
        display: grid;
        grid-template-rows: 40px auto;
    }

    .company {
        display: flex;
        gap: 20px;
        position: sticky;
        top: 0px;
        background: #f5f5f5;
        padding: 0px 10px;
        z-index: 1;
        align-items: center;
    }

    .products {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        row-gap: 20px;
        padding: 10px;
    }

    .product {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 200px;

        background: white;
        border-radius: 5px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        padding: 20px;
        cursor: pointer;
    }

    .product:hover {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    }

    .name {
        overflow-wrap: break-word; /* Modern standard */
        word-wrap: break-word; /* Legacy fallback for older browsers */
    }

    img {
        object-fit: contain;
        max-width: 100%;
        max-height: 100px;
        width: auto;
        height: auto;
    }

    .price {
        font-weight: bold;
        font-size: 20px;
        margin-top: auto;
        align-self: center;
    }

    .currency {
        opacity: 0.2;
        font-size: 16px;
    }

    .item {
        margin-bottom: 20px;
    }

    .item a {
        color: rgb(66, 66, 233);
        text-decoration: underline;
    }

    @media only screen and (max-device-width: 600px) {
        .container {
            grid-template-rows: 70px auto;
        }

        .product {
            width: 160px;
            padding: 10px;
        }

        img {
            max-height: 80px;
        }

        .name {
            font-size: 14px;
        }

        .price {
            font-size: 16px;
        }
    }
</style>
